import { C, ink } from '../lib/theme';

/**
 * Avatar de usuário — foto quando existe, iniciais em gradiente quando não
 * (mesmo visual que o `ProfileMenu` já usava antes de ter foto de verdade,
 * agora extraído pra reuso: header, sidebar, tags de auditoria estilo Slack).
 */
export function Avatar({ url, email, size = 30, ring }: {
  url?: string | null;
  email: string;
  size?: number;
  /** Anel de destaque — usado no card de configurações pra dar ênfase à foto. */
  ring?: boolean;
}) {
  const initials = email.slice(0, 2).toUpperCase();
  const common: React.CSSProperties = {
    width: size, height: size, borderRadius: '50%', flex: 'none',
    boxShadow: ring ? `0 0 0 3px ${C.accent}45, 0 8px 22px -6px rgba(232,85,48,0.5)` : 'none',
  };

  if (url) {
    return <img src={url} alt={email} style={{ ...common, objectFit: 'cover', border: `1px solid ${ink(0.14)}` }} />;
  }

  return (
    <span style={{
      ...common, background: `linear-gradient(150deg, ${C.accent}, ${C.accentDeep})`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.38, fontWeight: 800, color: '#fff',
    }}>{initials}</span>
  );
}
